/**
 * Autocomplete Class
 *
 */
export default class Autocomplete {
    constructor(inpSelector, selectSelector, showAll = false, matchMode = 'startsWith') {
        let vm = this
        this.inp = document.querySelector(inpSelector)
        this.select = document.querySelector(selectSelector)
        this.currentFocus = -1
        this.maxItems = 10
        this.showAll = showAll
        this.matchMode = matchMode // 'startsWith' or 'contains'

        if (this.inp && this.select) {
            this.arr = this.getAutocompleteData(this.select)

            this.inp.addEventListener("input", function (e) {
                vm.onInput(this);
            });

            this.inp.addEventListener("keydown", function (e) {
                vm.onKeyDown(e, this);
            });

            this.inp.addEventListener("blur", function (e) {
                setTimeout(function() {
                    vm.closeAllLists();
                }, 150);
            });

            document.addEventListener("click", function (e) {
                vm.closeAllLists(e.target);
            });
        }
    }

    onKeyDown(e, element) {
        let x = document.getElementById(element.id + "autocomplete-list");
        if (x) x = x.getElementsByTagName("div");
        if (e.keyCode == 40) {
            this.currentFocus++;
            this.addActive(x);
        } else if (e.keyCode == 38) { //up
            /*If the arrow UP key is pressed,
            decrease the this.currentFocus variable:*/
            this.currentFocus--;
            /*and and make the current item more visible:*/
            this.addActive(x);
        } else if (e.keyCode == 13) {
            /*If the ENTER key is pressed, prevent the form from being submitted,*/
            e.preventDefault();
            if (this.currentFocus > -1) {
                /*and simulate a click on the "active" item:*/
                if (x) x[this.currentFocus].click();
            }
        }
    }

    onInput(element) {
        let a, b, i, val = element.value, vm = this;
        /*close any already open lists of autocompleted values*/
        this.closeAllLists();
        if (!val && !this.showAll) {
            return false;
        }
        this.currentFocus = -1;
        /*create a DIV element that will contain the items (values):*/
        a = document.createElement("DIV");
        a.setAttribute("id", element.id + "autocomplete-list");
        a.setAttribute("class", "autocomplete-items");
        /*append the DIV element as a child of the autocomplete container:*/
        element.parentNode.appendChild(a);

        let itemCounter = 0;
        /*for each item in the array...*/
        for (let i = 0; i < this.arr.length; i++) {
            let matchesFilter = false;
            let matchIndex = -1;

            if (this.showAll) {
                matchesFilter = true;
            } else {
                const searchText = this.arr[i].search.toUpperCase();
                const valUpper = val.toUpperCase();

                if (this.matchMode === 'contains') {
                    matchIndex = searchText.indexOf(valUpper);
                    matchesFilter = matchIndex !== -1;
                } else {
                    // default: 'startsWith'
                    matchesFilter = searchText.substr(0, val.length) === valUpper;
                    matchIndex = matchesFilter ? 0 : -1;
                }
            }

            if (matchesFilter) {
                /*create a DIV element for each matching element:*/
                b = document.createElement("DIV");

                if (this.showAll) {
                    /*show the complete displayLabel without highlighting*/
                    b.innerHTML = this.arr[i].displayLabel;
                } else {
                    /*make the matching letters bold:*/
                    if (matchIndex >= 0) {
                        const displayLabel = this.arr[i].displayLabel;
                        const searchText = this.arr[i].search;

                        // Find the match position in the displayLabel based on search text
                        const displayLabelUpper = displayLabel.toUpperCase();
                        const searchTextUpper = searchText.toUpperCase();
                        const valUpper = val.toUpperCase();

                        // Find where the search text appears in the display label
                        const searchInDisplayIndex = displayLabelUpper.indexOf(searchTextUpper);

                        if (searchInDisplayIndex >= 0) {
                            // Calculate the actual highlight position
                            const highlightStart = searchInDisplayIndex + matchIndex;
                            b.innerHTML = displayLabel.substr(0, highlightStart) +
                                "<strong>" + displayLabel.substr(highlightStart, val.length) + "</strong>" +
                                displayLabel.substr(highlightStart + val.length);
                        } else {
                            // If search text is not in display label, just show without highlighting
                            b.innerHTML = displayLabel;
                        }
                    } else {
                        b.innerHTML = this.arr[i].displayLabel;
                    }
                }

                /*insert a input field that will hold the current array item's value:*/
                b.innerHTML += "<input type='hidden' value='" + this.arr[i].value + "' data-return='" + this.arr[i].return + "'>";
                /*execute a function when someone clicks on the item value (DIV element):*/
                b.addEventListener("click", function (e) {
                    /*insert the value for the autocomplete text field:*/
                    vm.inp.value = this.getElementsByTagName("input")[0].getAttribute('data-return');
                    vm.select.value = this.getElementsByTagName("input")[0].value;

                    /*dispatch change event on select element:*/
                    vm.select.dispatchEvent(new Event('change'));

                    /*close the list of autocompleted values,
                    (or any other open lists of autocompleted values:*/
                    vm.closeAllLists();
                });
                a.appendChild(b);
                itemCounter++;
                if (itemCounter >= this.maxItems && !this.showAll) {
                    break;
                }
            }
        }
    }

    getAutocompleteData(select) {
        let data = []
        let options = select.options

        for (let i = 0; i < options.length; i++) {
            let displayLabel = options[i].getAttribute('data-display-label');
            data.push(
                {
                    'value': options[i].value,
                    'search': options[i].getAttribute('data-search'),
                    'return': options[i].getAttribute('data-return'),
                    'label': options[i].text,
                    'displayLabel': displayLabel ? displayLabel : options[i].text
                }
            )
        }

        return data
    }

    addActive(x) {
        /*a function to classify an item as "active":*/
        if (!x) return false;
        /*start by removing the "active" class on all items:*/
        this.removeActive(x);
        if (this.currentFocus >= x.length) this.currentFocus = 0;
        if (this.currentFocus < 0) this.currentFocus = (x.length - 1);
        /*add class "autocomplete-active":*/
        x[this.currentFocus].classList.add("autocomplete-active");
    }

    removeActive(x) {
        /*a function to remove the "active" class from all autocomplete items:*/
        for (let i = 0; i < x.length; i++) {
            x[i].classList.remove("autocomplete-active");
        }
    }

    closeAllLists(element) {
        /*close all autocomplete lists in the document,
        except the one passed as an argument:*/
        let x = document.getElementsByClassName("autocomplete-items");
        for (let i = 0; i < x.length; i++) {
            if (element != x[i] && element != this.inp) {
                x[i].parentNode.removeChild(x[i]);
            }
        }
    }
}